import { useSelector } from 'react-redux';
import Title from 'ui/Typography/Title';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums/lib';
import Body from 'ui/Typography/Body';
import {
  KompisSheetBody,
  KompisSheetBodyPadding,
  KompisSheetFooter,
  KompisSheetFooterButtons
} from '@inter-ikea-kompis/react-components';
import Sheet from 'ui/Sheet/Sheet';
import { useAppDispatch } from 'ducks/hooks';
import { changeToSoftClosingFunctionAndAddHandles } from 'rangeConfig/besta/utils/doorClosingFunction';
import { useCore } from 'contexts/core';
import SheetHeader from 'ui/Sheet/SheetHeader';
import { useIntl } from 'react-intl';
import { getMarketProducts, getSelectedGroupId } from 'ducks/products';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { MenuType } from 'analytics/interaction';
import { getHandleId, hidePushToOpenSheet, isModalVisible } from './PushToOpenFeature';
import { useBehaviorTracker } from 'contexts/behaviors';

export const PushToOpenSheet = () => {
  const dispatch = useAppDispatch();
  const visible = !!useSelector(isModalVisible);
  const coreApi = useCore();
  const handleId = useSelector(getHandleId) ?? '';
  const products = useSelector(getMarketProducts);
  const { formatMessage } = useIntl();
  const behaviorTracker = useBehaviorTracker();
  const selectedGroupId = useSelector(getSelectedGroupId);

  const onClose = () => dispatch(hidePushToOpenSheet());
  const onPrimaryButtonClick = () => {
    changeToSoftClosingFunctionAndAddHandles(handleId, coreApi, products);
    onClose();
  };

  const handleButtonClick = (event: any) => {
    const actionTaken = event.detail.type === 'primaryButton';
    // Sheet has no widget context
    const behaviorContext = {
      groupId: selectedGroupId,
      menuType: 'sheet' as MenuType,
      widgetId: 'push-to-open-sheet',
      meta: { actionTaken }
    };

    behaviorTracker.withContext(behaviorContext).custom(() => {
      actionTaken ? onPrimaryButtonClick() : onClose();
    });
  };

  return (
    <Sheet onOverlayClick={onClose} visible={visible}>
      <SheetHeader onCloseButtonClick={onClose} />
      <KompisSheetBody theme={SkapaTheme}>
        <KompisSheetBodyPadding theme={SkapaTheme}>
          <Title type={ThemeFontStyleTypeEnum.headingMedium}>
            {formatMessage({ id: 'storageone.pushToOpenSheetTitle' })}
          </Title>
          <Body mt="l" type={ThemeFontStyleTypeEnum.bodyLarge}>
            {formatMessage({ id: 'storageone.pushToOpenSheetBody' })}
          </Body>
        </KompisSheetBodyPadding>
      </KompisSheetBody>
      <KompisSheetFooter theme={SkapaTheme}>
        <KompisSheetFooterButtons
          theme={SkapaTheme}
          primaryLabel={formatMessage({ id: 'storageone.pushToOpenSheetPrimaryButton' })}
          secondaryLabel={formatMessage({
            id: 'storageone.pushToOpenSheetSecondaryButton'
          })}
          onButtonClick={handleButtonClick}
        />
      </KompisSheetFooter>
    </Sheet>
  );
};

export default PushToOpenSheet;
